import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./SliderPartner.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function ParentSlider(props) {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: false,
        },
      },
    ],
  };
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 700 },
      items: 2,
    },

    mobile: {
      breakpoint: { max: 700, min: 0 },
      items: 1,
      justify: "center",
    },
  };
  return (
    <div className="partner_slider">
      <Carousel
        swipeable={false}
        draggable={false}
        showDots={mobileView ? false : true}
        responsive={responsive}
        //ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={1000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
        //deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
      >
        {props.partner &&
          props.partner.map(
            (partner, index) =>
              partner.logo != "" && (
                <img
                  key={index}
                  className="slider_img"
                  src={partner.logo}
                  alt={"icon"}
                  style={{
                    marginBottom: "45px",
                    height: "90px",
                    width: "auto",
                  }}
                />
              )
          )}
      </Carousel>
    </div>
  );
}
const Slide = ({ view, partner }) => {
  return <img className="slider_img" src={partner.logo} alt="icon" />;
};
export default ParentSlider;
